/**
 * Every comune Verde Vercelli serves, for the Zone page's table and map: the
 * provincia di Vercelli from Lozzolo and Gattinara down to the Po — 55 comuni
 * (names as on it.wikipedia «Provincia di Vercelli», read 2026-09-28) — plus
 * Novara and Casale Monferrato across the border. The Valsesia (Serravalle
 * Sesia and up) is the partner Verde Valsesia's (owner 2026-09-28), so its
 * comuni are not listed. Alphabetical.
 *
 * `key` indexes `copy.zone.notes` (one checked fact per town, both locales).
 * The detailed rows behind the SEO data (altitude, distance) stay in ./comuni.ts.
 */
export interface ServedComune {
  key: string
  name: string
  province: 'VC' | 'NO' | 'AL'
  /** The comune's ISTAT point (src/core/data/comuni.json), for its dot on the Zone map. */
  lat: number
  lon: number
}

export const SERVED_COMUNI: readonly ServedComune[] = [
  { key: 'albano-vercellese', name: 'Albano Vercellese', province: 'VC', lat: 45.4251, lon: 8.3806 },
  { key: 'alice-castello', name: 'Alice Castello', province: 'VC', lat: 45.3665, lon: 8.0747 },
  { key: 'arborio', name: 'Arborio', province: 'VC', lat: 45.4961, lon: 8.389 },
  { key: 'asigliano-vercellese', name: 'Asigliano Vercellese', province: 'VC', lat: 45.2612, lon: 8.4062 },
  { key: 'balocco', name: 'Balocco', province: 'VC', lat: 45.4555, lon: 8.281 },
  { key: 'bianze', name: 'Bianzè', province: 'VC', lat: 45.3074, lon: 8.1201 },
  { key: 'borgo-d-ale', name: "Borgo d'Ale", province: 'VC', lat: 45.3499, lon: 8.0537 },
  { key: 'borgo-vercelli', name: 'Borgo Vercelli', province: 'VC', lat: 45.3572, lon: 8.4664 },
  { key: 'buronzo', name: 'Buronzo', province: 'VC', lat: 45.4821, lon: 8.2683 },
  { key: 'caresana', name: 'Caresana', province: 'VC', lat: 45.2211, lon: 8.5065 },
  { key: 'caresanablot', name: 'Caresanablot', province: 'VC', lat: 45.3574, lon: 8.3888 },
  { key: 'carisio', name: 'Carisio', province: 'VC', lat: 45.4085, lon: 8.1986 },
  { key: 'casale-monferrato', name: 'Casale Monferrato', province: 'AL', lat: 45.135, lon: 8.4526 },
  { key: 'casanova-elvo', name: 'Casanova Elvo', province: 'VC', lat: 45.3995, lon: 8.2933 },
  { key: 'cigliano', name: 'Cigliano', province: 'VC', lat: 45.3096, lon: 8.0215 },
  { key: 'collobiano', name: 'Collobiano', province: 'VC', lat: 45.3971, lon: 8.3485 },
  { key: 'costanzana', name: 'Costanzana', province: 'VC', lat: 45.2362, lon: 8.3701 },
  { key: 'crescentino', name: 'Crescentino', province: 'VC', lat: 45.1923, lon: 8.1026 },
  { key: 'crova', name: 'Crova', province: 'VC', lat: 45.33, lon: 8.2119 },
  { key: 'desana', name: 'Desana', province: 'VC', lat: 45.2687, lon: 8.3575 },
  { key: 'fontanetto-po', name: 'Fontanetto Po', province: 'VC', lat: 45.1934, lon: 8.1917 },
  { key: 'formigliana', name: 'Formigliana', province: 'VC', lat: 45.4288, lon: 8.2929 },
  { key: 'gattinara', name: 'Gattinara', province: 'VC', lat: 45.6173, lon: 8.3713 },
  { key: 'ghislarengo', name: 'Ghislarengo', province: 'VC', lat: 45.5293, lon: 8.3843 },
  { key: 'greggio', name: 'Greggio', province: 'VC', lat: 45.4518, lon: 8.3825 },
  { key: 'lamporo', name: 'Lamporo', province: 'VC', lat: 45.2301, lon: 8.0976 },
  { key: 'lenta', name: 'Lenta', province: 'VC', lat: 45.5556, lon: 8.3844 },
  { key: 'lignana', name: 'Lignana', province: 'VC', lat: 45.2853, lon: 8.346 },
  { key: 'livorno-ferraris', name: 'Livorno Ferraris', province: 'VC', lat: 45.2817, lon: 8.082 },
  { key: 'lozzolo', name: 'Lozzolo', province: 'VC', lat: 45.6226, lon: 8.3221 },
  { key: 'moncrivello', name: 'Moncrivello', province: 'VC', lat: 45.3312, lon: 7.9959 },
  { key: 'motta-de-conti', name: "Motta de' Conti", province: 'VC', lat: 45.1915, lon: 8.5208 },
  { key: 'novara', name: 'Novara', province: 'NO', lat: 45.4459, lon: 8.6219 },
  { key: 'olcenengo', name: 'Olcenengo', province: 'VC', lat: 45.3636, lon: 8.3114 },
  { key: 'oldenico', name: 'Oldenico', province: 'VC', lat: 45.4024, lon: 8.3827 },
  { key: 'palazzolo-vercellese', name: 'Palazzolo Vercellese', province: 'VC', lat: 45.1845, lon: 8.2328 },
  { key: 'pertengo', name: 'Pertengo', province: 'VC', lat: 45.2356, lon: 8.4176 },
  { key: 'pezzana', name: 'Pezzana', province: 'VC', lat: 45.2621, lon: 8.4842 },
  { key: 'prarolo', name: 'Prarolo', province: 'VC', lat: 45.2822, lon: 8.4793 },
  { key: 'quinto-vercellese', name: 'Quinto Vercellese', province: 'VC', lat: 45.3805, lon: 8.3622 },
  { key: 'rive', name: 'Rive', province: 'VC', lat: 45.2126, lon: 8.4183 },
  { key: 'roasio', name: 'Roasio', province: 'VC', lat: 45.6086, lon: 8.2889 },
  { key: 'ronsecco', name: 'Ronsecco', province: 'VC', lat: 45.2535, lon: 8.2778 },
  { key: 'rovasenda', name: 'Rovasenda', province: 'VC', lat: 45.5368, lon: 8.3136 },
  { key: 'salasco', name: 'Salasco', province: 'VC', lat: 45.3253, lon: 8.2638 },
  { key: 'sali-vercellese', name: 'Sali Vercellese', province: 'VC', lat: 45.3093, lon: 8.3297 },
  { key: 'saluggia', name: 'Saluggia', province: 'VC', lat: 45.2358, lon: 8.0111 },
  { key: 'san-germano-vercellese', name: 'San Germano Vercellese', province: 'VC', lat: 45.3502, lon: 8.2509 },
  { key: 'san-giacomo-vercellese', name: 'San Giacomo Vercellese', province: 'VC', lat: 45.4974, lon: 8.3253 },
  { key: 'santhia', name: 'Santhià', province: 'VC', lat: 45.3669, lon: 8.1744 },
  { key: 'stroppiana', name: 'Stroppiana', province: 'VC', lat: 45.2314, lon: 8.4535 },
  { key: 'tricerro', name: 'Tricerro', province: 'VC', lat: 45.2338, lon: 8.3251 },
  { key: 'trino', name: 'Trino', province: 'VC', lat: 45.1942, lon: 8.2969 },
  { key: 'tronzano-vercellese', name: 'Tronzano Vercellese', province: 'VC', lat: 45.3428, lon: 8.1747 },
  { key: 'vercelli', name: 'Vercelli', province: 'VC', lat: 45.324, lon: 8.4232 },
  { key: 'villarboit', name: 'Villarboit', province: 'VC', lat: 45.4367, lon: 8.3369 },
  { key: 'villata', name: 'Villata', province: 'VC', lat: 45.3856, lon: 8.4326 },
]

/** The served comuni of the provincia di Vercelli (55): the Zone map's dots and the home band's count. */
export const VC_COMUNI: readonly ServedComune[] = SERVED_COMUNI.filter((c) => c.province === 'VC')

/**
 * Two province figures for the home Zone band, from it.wikipedia «Provincia di
 * Vercelli» (read 2026-09-28): «2 081,64 km²» (infobox, rounded) and «71.000
 * ettari» of rice paddies («quasi il 70% della produzione e della superficie
 * piemontese»).
 */
export const PROVINCE_AREA_KM2 = 2082
export const PROVINCE_RICE_HA = 71000
